/* ============================================================
   NBBTOOLS — Navigation & Interactive Behaviors
   ============================================================ */

/* ── Mobile Menu Toggle ── */
function toggleMobileMenu() {
  var nav = document.querySelector('.header-categories');
  var btn = document.getElementById('menuToggle');
  if (!nav || !btn) return;

  var isOpen = nav.classList.contains('open');
  if (isOpen) {
    nav.classList.remove('open');
    btn.classList.remove('active');
  } else {
    nav.classList.add('open');
    btn.classList.add('active');
  }
}

/* ── Sticky Navigation ── */
(function() {
  var stickyContainer = document.getElementById('sticky-menu-container');
  if (!stickyContainer) return;

  var stickyPos = stickyContainer.offsetTop;
  var ticking = false;

  function updateSticky() {
    if (window.scrollY >= stickyPos) {
      if (!stickyContainer.classList.contains('fixed')) {
        stickyContainer.classList.add('fixed');
        document.body.style.paddingTop = stickyContainer.offsetHeight + 'px';
      }
    } else {
      if (stickyContainer.classList.contains('fixed')) {
        stickyContainer.classList.remove('fixed');
        document.body.style.paddingTop = '';
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateSticky);
      ticking = true;
    }
  });
})();

/* ── Mega Menu Overflow Repositioning ── */
(function() {
  document.querySelectorAll('.top-level-menu > li').forEach(function(li) {
    li.addEventListener('mouseenter', function() {
      var container = li.querySelector('.grid-menu-container');
      if (!container) return;
      container.style.display = 'block';
      var rect = container.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        container.style.left = 'auto';
        container.style.right = '0';
      }
    });
    li.addEventListener('mouseleave', function() {
      var container = li.querySelector('.grid-menu-container');
      if (!container) return;
      container.style.display = '';
      container.style.left = '';
      container.style.right = '';
    });
  });
})();

/* ── Product variant selector ── */
(function() {
  var idInput = document.querySelector('.product-form__variant-id');
  var priceEl = document.querySelector('.product-form__price');
  var skuEls = document.querySelectorAll('.js-variant-sku');
  var mainImg = document.querySelector('.js-main-image');
  var selector = document.querySelector('[data-variant-selector]');
  if (!selector || !idInput) return;
  selector.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      selector.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      idInput.value = btn.getAttribute('data-variant-id');
      if (priceEl && btn.getAttribute('data-variant-price')) {
        priceEl.textContent = btn.getAttribute('data-variant-price');
      }
      var sku = btn.getAttribute('data-variant-sku');
      if (sku) {
        skuEls.forEach(function(el) { el.textContent = sku; });
      }
      if (mainImg) {
        var defaultSrc = mainImg.getAttribute('data-default-src') || mainImg.src;
        var defaultFull = mainImg.getAttribute('data-default-full') || mainImg.getAttribute('data-full');
        mainImg.src = btn.getAttribute('data-variant-image') || defaultSrc;
        mainImg.setAttribute('data-full', btn.getAttribute('data-variant-image-full') || defaultFull);
        var newAlt = btn.getAttribute('data-variant-image-alt');
        if (newAlt) mainImg.alt = newAlt;
      }
    });
  });
})();

/* ── Product quantity selector ── */
(function() {
  var control = document.querySelector('.qty-selector__control');
  if (!control) return;
  var input = control.querySelector('.qty-selector__input');
  if (!input) return;
  control.querySelectorAll('.qty-selector__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = 1;
      val += step;
      if (val < 1) val = 1;
      input.value = val;
    });
  });
})();

/* ── Cart quantity stepper ── */
(function() {
  document.querySelectorAll('.cart-item__qty').forEach(function(form) {
    var input = form.querySelector('input[name="quantity"]');
    if (!input) return;
    form.querySelectorAll('[data-cart-qty-step]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var step = parseInt(btn.getAttribute('data-cart-qty-step'), 10) || 0;
        var val = parseInt(input.value, 10);
        if (isNaN(val)) val = 1;
        val += step;
        if (val < 1) val = 1;
        input.value = val;
        form.submit();
      });
    });
  });
})();

/* ── ESC closes all ── */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var nav = document.querySelector('.header-categories');
    var btn = document.getElementById('menuToggle');
    if (nav) nav.classList.remove('open');
    if (btn) btn.classList.remove('active');
  }
});

/* ── Product image lightbox ── */
(function() {
  var lightbox = document.getElementById('productLightbox');
  if (!lightbox) return;
  var img = lightbox.querySelector('.lightbox__img');
  var closeBtn = lightbox.querySelector('.lightbox__close');
  var prevBtn = lightbox.querySelector('.lightbox__prev');
  var nextBtn = lightbox.querySelector('.lightbox__next');
  var mainImg = document.querySelector('.js-main-image');
  var thumbs = document.querySelectorAll('.thumb');

  // 所有图片（按缩略图顺序），用于 lightbox 左右切换
  var images = [];
  thumbs.forEach(function(thumb) {
    images.push({ src: thumb.getAttribute('data-full'), alt: thumb.getAttribute('data-alt') || '' });
  });
  var current = 0;

  if (images.length <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
  }

  function open(src, alt) {
    if (img) { img.src = src; if (alt) img.alt = alt; }
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (img) img.src = '';
  }
  function show(i) {
    if (!images.length) return;
    current = (i + images.length) % images.length;
    if (img) { img.src = images[current].src; if (images[current].alt) img.alt = images[current].alt; }
  }
  function indexOfCurrent() {
    if (!mainImg) return 0;
    var cur = mainImg.getAttribute('src');
    var idx = 0;
    thumbs.forEach(function(thumb, i) {
      if (thumb.getAttribute('data-src') === cur) idx = i;
    });
    return idx;
  }

  if (mainImg) {
    mainImg.addEventListener('click', function() {
      current = indexOfCurrent();
      open(mainImg.getAttribute('data-full'), mainImg.getAttribute('alt'));
    });
  }

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.setAttribute('data-full', thumb.getAttribute('data-full'));
      var alt = thumb.getAttribute('data-alt');
      if (alt) mainImg.alt = alt;
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
    thumb.addEventListener('dblclick', function() {
      current = i;
      open(thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'));
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });

  if (closeBtn) closeBtn.addEventListener('click', close);
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) close();
  });
  document.addEventListener('keydown', function(e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* ── Related products hover pager + dots ── */
(function() {
  var wrap = document.querySelector('[data-related-scroll]');
  if (!wrap) return;
  var track = wrap.querySelector('.related-scroll__track');
  var dotsWrap = wrap.querySelector('[data-related-dots]');
  if (!track || !dotsWrap) return;

  var cards = track.querySelectorAll('.product-card');
  if (!cards.length) return;

  var current = 0;

  function perPage() {
    var cw = cards[0].getBoundingClientRect().width;
    return Math.max(1, Math.round((track.clientWidth + 16) / (cw + 16)));
  }
  function pageCount() {
    return Math.max(1, Math.ceil(cards.length / perPage()));
  }
  function build() {
    var n = pageCount();
    dotsWrap.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'related-dot' + (i === current ? ' is-active' : '');
      d.setAttribute('aria-label', 'Página ' + (i + 1));
      d.setAttribute('data-page', i);
      d.addEventListener('mouseenter', function() {
        goTo(parseInt(this.getAttribute('data-page'), 10));
      });
      d.addEventListener('touchstart', function(e) {
        e.preventDefault();
        goTo(parseInt(this.getAttribute('data-page'), 10));
      }, { passive: false });
      dotsWrap.appendChild(d);
    }
  }
  function goTo(page) {
    current = Math.max(0, Math.min(pageCount() - 1, page));
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dotsWrap.querySelectorAll('.related-dot').forEach(function(d, i) {
      d.classList.toggle('is-active', i === current);
    });
  }

  build();
  window.addEventListener('resize', function() {
    build();
    goTo(current);
  });
})();

/* ── Hero auto carousel ── */
(function() {
  var carousel = document.querySelector('[data-hero-carousel]');
  if (!carousel) return;
  var slides = carousel.querySelectorAll('.hero-slide');
  var dotsWrap = carousel.querySelector('[data-hero-dots]');
  if (!slides.length) return;

  var current = 0;
  var timer = null;
  var INTERVAL = 4000;

  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    for (var i = 0; i < slides.length; i++) {
      (function(idx) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'hero-dot' + (idx === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Diapositiva ' + (idx + 1));
        d.addEventListener('click', function() { goTo(idx); restart(); });
        dotsWrap.appendChild(d);
      })(i);
    }
  }

  function goTo(i) {
    slides[current].classList.remove('is-active');
    current = (i + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.hero-dot').forEach(function(d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
    }
  }

  function next() { goTo(current + 1); }
  function start() { if (timer) clearInterval(timer); timer = setInterval(next, INTERVAL); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function restart() { stop(); start(); }

  buildDots();
  start();

  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
})();
